import { PushFeedbackRequestData } from '../common/Types';
import { Util } from '../common/Util';
import { CentralConfig } from '../config/CentralConfig';
import { StorageService } from '../storage/StorageService';

export class InstantPushController {
	private readonly _storage: StorageService;
	private readonly _centralConfig: CentralConfig;

	constructor(centralConfig: CentralConfig, storage: StorageService) {
		this._centralConfig = centralConfig;
		this._storage = storage;
	}

	checkAndRemoveExpiredTriggeredDateTimes() {
		const userState = this._storage.readUserState();
		if (userState) {
			userState.instantPushState.checkAndRemoveExpiredTriggeredDateTimes();
			this._storage.saveUserState(userState);
		}
	}

	isInstantPush(pushData: PushFeedbackRequestData): boolean {
		const { areaId, triggerName } = pushData;
		const combinedKey = Util.getCombinedKey(areaId, triggerName);
		const instantPushConfigsMap = this._centralConfig.pushConfig?.instantPushConfigs;
		if (instantPushConfigsMap && instantPushConfigsMap.size > 0) {
			if (instantPushConfigsMap.has(combinedKey)) {
				return true;
			}
		}
		return false;
	}

	isDailyLimitReached(): boolean {
		this.checkAndRemoveExpiredTriggeredDateTimes();
		const dailyLimitCount = this._centralConfig.pushConfig?.instantPushDailyLimit;
		const userState = this._storage.readUserState();
		if (dailyLimitCount && userState) {
			const triggeredDateTimes = userState.instantPushState.getTriggeredDateTimes();
			return triggeredDateTimes.length >= dailyLimitCount;
		}
		return false;
	}
}
